// 我的文件 未添加到文件夹
import React, { useContext, useState, useEffect, useMemo, useCallback } from "react";
import api from "../../api";
import contextMenus, { Names } from "../../contextMenus";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import events from "../../context/events";
import TableList from "../../components/TableList";
import { ColumnsItem, JustifyContent } from "../../components/TableList/BaseComponents/Header";
import { getIconUrl, openLink, partialRefresh, time } from "../../util";
import { changeEgovUrl } from "@/utils/tools";
import ContextMenu, { IContextRender } from "../../components/List/ContextMenu";
import { Icons } from "../../Icon";
import { message, Modal } from "antd";
import Tags, { TagType } from "../../components/Tags";
import context from "../../context";
import Filters from "../../components/List/Filters";
import { Order, Sort, timeFilter, titleFilter } from "../../components/List/Filters/config";
import BatchControl from "../../components/List/BatchControlNew";
import { folderType, folderTypeEnum } from "../../config/permissions.config";
import batchOperate, { PageRouteName } from "../../batchOperate";
import { connect } from "dvajs";
import { JoyspaceState } from "@/models/joyspace";
import { pageSize } from "../../config/basics.config";
import { getUser } from "@/utils";
import { AuthData } from "@/types/LocalConfig";
import SyncStatusTag from "../../components/SyncStatusTag";
import JoyspaceController, {
  SyncStatusEunm
} from "@/components/Joyspace/controllers/JoyspaceController";
import openDeleteModal from "../../contextModal/DeleteModal";
import openErrorDeleteModal from "../../contextModal/ErrorDeleteModal";
import { ActionFnEnum, ActionType, ContextMenuMode, FileType, MenusType } from "../../types";
import { PermissionEnum } from "../../const";
import UpdataService from "../../reloadUtils";
import { useNavigator } from "@/utils/NetworkCheck";
import { useListData } from "../../components/TableList/Use/useListData";

// let params = {
//     srot: Sort.UpDateTime,
//     order: Order.DESC,
// };
let filterInfo: any = {
  srot: Sort.UpDateTime,
  order: Order.DESC
};
interface IProps {
  _filterInfo: any;
  currentRouterInfo: any;
}
const PartialUpdata = Object.create(UpdataService);
const key = MenusType.SPACE;
function ListPages(props: IProps) {
  const { _filterInfo } = props;
  filterInfo = _filterInfo;
  const globalContext = useContext<GlobalContextConfig>(GlobalContext);
  const {
    list,
    setList,
    total,
    setTotal,
    loading,
    isLoadMore,
    setLoadMore,
    selecteds,
    select,
    onButtom,
    setPageIndex
  } = useListData({ requestPagesFunc: api.pages.space, key });
  const { user, currentRouterInfo } = useContext(context);
  const { onLine } = globalContext;
  const [defaultCheckedList, setDefaultCheckedList] = useState<string[]>([]);
  const [columns, setColumns] = useState<ColumnsItem[]>([
    {
      title: "",
      key: "title",
      dataIndex: "title",
      ellipsis: true,
      filters: true,
      render: () => (
        <Filters from={getPageRouteName()} isArrowDownIcon={true} menu={titleFilter()} />
      )
    },
    {
      title: "",
      key: "time",
      dataIndex: "time",
      width: "20%",
      style: {
        minWidth: "142px"
      },
      justifyContent: JustifyContent.Left,
      filters: true,
      render: () => <Filters from={getPageRouteName()} menu={timeFilter()} />
    },
    {
      title: "",
      key: "actions",
      dataIndex: "actions",
      actions: true,
      width: "10%",
      style: {
        minWidth: "30px"
      },
      justifyContent: JustifyContent.Center
    }
  ]);
  const [isMySpace, setIsMySpacePage] = useState<boolean>(true);
  const [defalutSpaceId, setDefalutSpaceId] = useState<folderType | null>(null);
  useEffect(() => {
    if (!currentRouterInfo) {
      console.warn("currentRouterInfo_null_Error");
      return;
    }
    setDefaultCheckedList([]);

    if (currentRouterInfo.type === folderTypeEnum.SHARE && defalutSpaceId !== folderType.SHARE) {
      setDefalutSpaceId(folderType.SHARE);
      setIsMySpacePage(false);
      return;
    }
    if (currentRouterInfo.type === folderTypeEnum.MY && defalutSpaceId !== folderType.MY) {
      setDefalutSpaceId(folderType.MY);
      setIsMySpacePage(true);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRouterInfo]);

  useMemo(() => {
    let _columns = [...columns];
    const index = _columns.findIndex((item) => item.key === "checkbox");
    const item = _columns.filter((item) => item.filters);
    if (onLine && index === -1) {
      _columns.unshift({
        title: "",
        key: "checkbox",
        checkbox: true,
        dataIndex: "id",
        width: 30
      });
    } else if (!onLine && index !== -1) {
      _columns.splice(0, 1);
    }
    setColumns(_columns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLine]);

  const getPageRouteName = () => {
    switch (currentRouterInfo?.type) {
      case folderTypeEnum.MY:
        return PageRouteName.MY_SPACE_PAGE;
      case folderTypeEnum.SHARE:
        return PageRouteName.TEAM_SPACE_PAGE;
      default:
        return PageRouteName.GROUP;
    }
  };

  const openPage = (columnsItem: ColumnsItem, item: any) => {
    // console.log(columnsItem, '=====', item);
    if (!item.status && useNavigator.onLine) {
      openDeleteModal(FileType.Page, item.id);
      return;
    }
    if (item.syncStatus === SyncStatusEunm.PROCESS) {
      message.error("文档同步中，请同步完成后查看");
      return;
    }
    if (item.syncStatus === SyncStatusEunm.DATAERROR) {
      openErrorDeleteModal(item);
      return;
    }
    if (columnsItem.key === "title") {
      openLink(item, globalContext.appRuntimeEnv.joyspaceHost);
    }
  };
  const getCheckedIds = (ids: string[] = []) => {
    const reslut = columns.find((item: ColumnsItem) => item.checkbox);
    // const node: any = document.getElementsByClassName('myspace-list-wrap')[0];
    if (!reslut) {
      return;
    }
    const _set = new Set();
    for (let id of ids) {
      for (let item of list) {
        if (item[reslut.dataIndex] === id) {
          _set.add(item);
        }
      }
    }
    select(_set);
  };
  const setData = useCallback((data: any) => {
    events.emit("list.partial.refresh", {
      changeData: data,
      key
    });
  }, []);
  useEffect(() => {
    events.on("table-setData", setData);
    return () => {
      events.off("table-setData", setData);
    };
  }, [setData]);
  return (
    <div className="joyspace-list-table">
      <TableList
        isLoadMore={isLoadMore}
        columns={columns}
        list={list}
        from={getPageRouteName()}
        loading={loading}
        pagination={true}
        defaultCheckedList={defaultCheckedList}
        folderFrom={{
          folderId: currentRouterInfo?.id === "myspace" ? "" : currentRouterInfo?.id,
          fromName: currentRouterInfo?.name === "myspace" ? "" : currentRouterInfo?.name,
          canDraggerUpload: onLine,
          draggerUploadShow: true
        }}
        renderActions={(item: any, contextMenuMode = ContextMenuMode.Click) => {
          // if (item.isDisabled) {
          //     return (
          //         <span className="joyspace-trigger-icon" style={{ color: '#cccccc' }}>
          //             {Icons.trigger}
          //         </span>
          //     );
          // }
          return (
            <ContextMenu
              render={contextMenus.page("MY_SPACE", globalContext, currentRouterInfo)}
              callbackProps={{
                contextMenuMode,
                data: item,
                originId: currentRouterInfo?.id,
                setData,
                remove: () => {
                  console.log("remove");
                },
                reload: () => {
                  console.log("reload");
                }
              }}
            />
          );
        }}
        preOptions={(item: any, data: any, isExist: any) => {
          return (
            item.dataIndex === "title" && (
              <img
                src={
                  !isExist ? changeEgovUrl(data.icon_url) : getIconUrl(data.type || data.page_type)
                }
                data-icon
              />
            )
          );
        }}
        afterOptions={(item, data) => {
          return (
            item.dataIndex === "title" &&
            data.isCollected && <Tags left={5} TagType={TagType.Follow} />
          );
        }}
        contentRender={(columnsItem: ColumnsItem, item: any) => {
          return (
            columnsItem.dataIndex === "time" &&
            item.isNew && <SyncStatusTag status={item.syncStatus} />
          );
        }}
        onButtom={onButtom}
        handleItem={openPage}
        getCheckedIds={getCheckedIds}
        footerHeight={50}
        allowDraggble={true}
        footerRender={() => {
          return (
            <BatchControl
              key={key}
              selecteds={selecteds as any}
              select={select}
              // type={isMySpace ? "MY_SPACE" : "TEAM_SPACE"}
              render={contextMenus.page("MY_SPACE", globalContext, currentRouterInfo)}
              categoryRender={contextMenus.category(
                isMySpace ? "MY_SPACE" : "TEAM_SPACE",
                currentRouterInfo
              )}
              batchRender={batchOperate.batch(
                isMySpace ? "MY_SPACE" : "TEAM_SPACE",
                currentRouterInfo
              )}
              callbackProps={{
                // data: selecteds,
                originId: currentRouterInfo?.id,
                setData: setData
              }}
            />
          );
        }}
      />
    </div>
  );
}

function mapStateToProps({ joyspace }: { joyspace: JoyspaceState }) {
  // console.log(joyspace, ' joyspace.folderInfo===>');
  return {
    currentRouterInfo: joyspace.currentRouterInfo,
    _filterInfo: joyspace.filterInfo
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    getFolderInfoById(id: any, params: any) {
      return dispatch({
        type: "joyspace/freshFolderTreeById",
        payload: {
          id,
          params
        }
      });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ListPages);
